export const pluralize = (word: string | undefined, itemCount: any, end = 's') => {
  if (typeof word !== 'string') { return '' }
  if (typeof itemCount !== 'number' || itemCount < 0) { return word }
  return itemCount === 1 ? word : word + end
}

// Currency formatter
export const formatToUSDCurrency = (num: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })

  return formatter.format(num).replace('.00', '')
}

export const truncate = (text, length, tail = '...', replaceBR = false) => {
  if (!text) { return '' }
  const textLength = text.length
  if (!textLength) { return '' }
  if (replaceBR) { text = text.replace(/<br[^>]*>/gi, '\n') }
  if (textLength < length) { return text }
  let truncated = text.substring(0, length - 3)
  if (tail) { truncated += tail }
  const matches = truncated.match(/(<([^>]+)>)/ig)
  if (!matches || matches.length % 2 === 0) { return truncated }
  return truncated.replace(/(<([^>]+)>)/ig, '')
}

export const withdrawalPeriod = (expirationPeriodType, expirationValue) => {
  const units = {
    day: 'daily',
    week: 'weekly',
    month: 'monthly',
    year: 'annually'
  }
  return expirationValue === 1
    ? units[expirationPeriodType]
    : `${expirationValue} ${expirationPeriodType}s`
}

export const alphaNumeric = str => str.replace(/[^a-zA-Z0-9/_ ]/g, '').replace(/\s\s+/g, ' ')
export const formatZip = str => str.replace(/\D+/g, '').substring(0, 5)
export const convertLabelValue = data => data
  ? Object.keys(data).map(key => ({ label: data[key], value: key }))
  : []
export const formatNumberToSimple = number => number.replace(/[^+\d]/g, '')
export const formatUSAPhoneNumber = (number) => {
  const x = number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
  return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? ' - ' + x[3] : '')
}
